import React from 'react';
import { Box, useWindowSize } from 'vindi-ds-components';
import { node } from 'prop-types';
import styles from './styles';
import EmptyStateAction from './action';
import EmptyStateActions from './actions';
import EmptyStateFooter from './footer';
import EmptyStateHeadline from './headline';
import EmptyStateTopImage from './top_image';
import mobileStyles from './mobile/styles';

function EmptyState({ children }) {
  const { isDesktop } = useWindowSize();
  const stylesCss = isDesktop ? styles : mobileStyles;

  return (
    <Box css={stylesCss.box}>
      {children}
    </Box>
  );
}

EmptyState.propTypes = {
  children: node.isRequired,
};

EmptyState.Action = EmptyStateAction;

EmptyState.Actions = EmptyStateActions;

EmptyState.Footer = EmptyStateFooter;

EmptyState.Headline = EmptyStateHeadline;

EmptyState.TopImage = EmptyStateTopImage;

export default EmptyState;
